import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { ThemeStyle } from '../../module/ThemeManager';
import { theme } from '../../constants/theme';
import { sunset } from '../../asset/images';

interface MediaCardProps {
    imageUrl: string;
    addressDescription: string;
    additionalDetail: string;
    onSelectClick: () => void;
    onDismissClick: () => void;
    sx?: SxProps<Theme>;
    themeStyle: ThemeStyle;
}

const MapCard: React.FC<MediaCardProps> = ({
    imageUrl,
    addressDescription,
    additionalDetail,
    onSelectClick,
    onDismissClick,
    sx,
    themeStyle,
}) => {
    return (
        <Card sx={{ minWidth: 345, maxWidth: 500, ...sx }}>
            <CardMedia sx={{ height: 140 }} image={imageUrl} title={addressDescription} />
            <CardContent>
                <Typography
                    sx={{
                        color: '#fff',
                        fontFamily: FONT_ENUM.REGULAR_HEADER,
                        fontSize: 34,
                    }}
                    component="div">
                    {addressDescription}
                </Typography>
                <Typography
                    sx={{
                        color: theme[themeStyle].dropdown_text,
                        fontFamily: FONT_ENUM.MAIN_REGULAR,
                        fontSize: 12,
                    }}>
                    {additionalDetail}
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" onClick={onSelectClick}>
                    Select
                </Button>
                <Button size="small" onClick={onDismissClick}>
                    Dismiss
                </Button>
            </CardActions>
        </Card>
    );
};

MapCard.defaultProps = {
    imageUrl: sunset,
};

export { MapCard };
